var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4555",
    "data-name": "Group 4555",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.234,
    height: 15.194,
    viewBox: "0 0 19.234 15.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 19.234,
    height: 15.194,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M217.479,357.2l1.3,1.739a6.824,6.824,0,0,0-1.807.9,1.053,1.053,0,1,1-1.187-1.74,9.14,9.14,0,0,1,1.689-.9",
    transform: "translate(-210.969 -349.972)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M477.615,330.491a1.052,1.052,0,0,1-1.344.125,6.774,6.774,0,0,0-1.937-.94l-1.727-2.3h.055a8.532,8.532,0,0,1,4.8,1.5,1.053,1.053,0,0,1,.158,1.615",
    transform: "translate(-463.043 -320.749)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M109.721,232.72l1.256,1.674a10.339,10.339,0,0,0-2.091,1.235,1.006,1.006,0,0,1-1.235-1.588,11.657,11.657,0,0,1,2.07-1.321",
    transform: "translate(-105.101 -228.011)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M375.4,178.585a1.007,1.007,0,0,1-1.323.091,9.6,9.6,0,0,0-5.832-2.024c-.274,0-.542.012-.8.034l-1.409-1.877a11.261,11.261,0,0,1,9.278,2.279,1.007,1.007,0,0,1,.088,1.5",
    transform: "translate(-358.633 -171.058)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M2.758,110.082,3.975,111.7a12.7,12.7,0,0,0-2.364,1.551.977.977,0,0,1-1.319-.06l-.009-.009a.975.975,0,0,1,.051-1.423,13.838,13.838,0,0,1,2.424-1.682",
    transform: "translate(0 -107.855)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M281.3,28.37l-.009.009a.977.977,0,0,1-1.319.06,12.528,12.528,0,0,0-10.9-2.562l-1.3-1.738a14.307,14.307,0,0,1,13.482,2.809.975.975,0,0,1,.051,1.423",
    transform: "translate(-262.354 -23.038)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M330.8,488.868a2.91,2.91,0,0,0-.375-.024,3.113,3.113,0,0,0-1.462.376,1.052,1.052,0,0,1-.982-1.86,5.3,5.3,0,0,1,1.305-.51Z",
    transform: "translate(-320.812 -476.999)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M419.931,636.65a1.168,1.168,0,1,1-1.168-1.168,1.168,1.168,0,0,1,1.168,1.168",
    transform: "translate(-409.146 -622.624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 1.608,
    height: 16.441,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, 2.558, 0.965)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmOffline);
export default __webpack_public_path__ + "static/media/sm-offline.fdb3cdb1.svg";
export { ForwardRef as ReactComponent };